import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { timeout, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const timeoutInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    timeout({ each: 15000 }),
    catchError(err => {
      if (err?.name === 'TimeoutError') {
        return throwError(() => new HttpErrorResponse({
          status: 0, statusText: 'CLIENT_TIMEOUT', url: req.url,
          error: { message: `Timed out after 15000ms`, method: req.method }
        }));
      }
      return throwError(() => err);
    })
  );
